import React, { useState, useEffect } from "react";
import { Container, FormGroup, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Loading } from "../../share/loading";
// import TextErrors from '../../share/TextErrors'
import CreateTableComponent from "../../share/CreateTableComponent";
import * as Yup from "yup";
import "../../share/form.css";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import { BsPlusLg } from "react-icons/bs";
import { useSearchParams } from "react-router-dom";
// import { format } from 'date-fns'

export function ChangeBorrowCourseFormComponent() {
  const [searchParams] = useSearchParams();
  let borrowId = searchParams.get("req")
  const [loading, setLoading] = useState(false);
  // ดึง cookie มาใช้
  const user = JSON.parse(localStorage.getItem("userData"));
  const [borrowInfo, setBorrowInfo] = useState([]);
  const [courseData, setCourseData] = useState([]);
  const [lawOcuData, setLawOcuData] = useState([]);
  const [lawOcuuByBorrowIdData, setLawOcuuByBorrowIdData] = useState([]);
  const [detailChangeCourse, setDetailChangeCourse] = useState([]);
  const [selectedCourseItem, setSelectedCourseItem] = useState(null);
  const [isCourseEditing, setIsCourseEditing] = useState(false);
  const [detailChangeLawOccupationData, setDetailChangeLawOccupationData] = useState([]);
  const [selectedTestItem, setSelectedTestItem] = useState(null);
  const [isTesteEditing, setIsTestEditing] = useState(false);

  // toggle ดำเนินการฝึกอบรม
  const [openModalForm, setOpenModalForm] = useState(false);
  const modalToggleExtendCourse = () => setOpenModalForm(!openModalForm);

  // toggle ดำเนินการทดสอบ
  const [openModalTestForm, setOpenModalTestForm] = useState(false);
  const modalToggleExtendTest = () => setOpenModalTestForm(!openModalTestForm);


  // ดึงข้อมูลการฝึกอบรม by borrow id 
  useEffect(() => {
    const getCourseByBorrowId = async () => {
      setLoading(true)
      try {
        let res = await fetch(`/api/ExtendAndChangeBorrow/getCourseByBorrowId/${borrowId}`);
        let resJson = await res.json();
        setCourseData(resJson.dataenum);
      } catch (e) {
        // console.log("err =>", e)

      } finally {
        setLoading(false)
      }

    }
    getCourseByBorrowId()

  }, [borrowId])

  // ดึงข้อมูลการดำเนินการทดสอบ by borrow id
  useEffect(() => {
    const getLawOccupationByBorrowId = async () => {
      setLoading(true)
      try {
        let res = await fetch(`/api/ExtendAndChangeBorrow/getLawOccupationByBorrowId/${borrowId}`);
        let resJson = await res.json();
        setLawOcuuByBorrowIdData(resJson.dataenum);
        // console.log("testData", resJson.dataenum);
      } catch (e) {
        // console.log("err =>", e)

      } finally {
        setLoading(false)
      }

    }
    getLawOccupationByBorrowId()
  }, [borrowId])

  useEffect(() => {
    const getBorrowInfo = async () => {
      setLoading(true)
      try {
        let res = await fetch(`/api/ExtendAndChangeBorrow/getInfoByBorrowId/${borrowId}`);
        let resJson = await res.json();
        setBorrowInfo(resJson.dataenum);
        // console.log("borrowInfo", resJson.dataenum);
      } catch (e) {
        // console.log("err =>", e)

      } finally {
        setLoading(false)
      }

    }
    getBorrowInfo()
  }, [borrowId])

  useEffect(() => {
    async function GetLawOcu() {
      setLoading(true);
      try {
        const res = await fetch("/api/Borrow/getLawOcuData");
        const data = await res.json();
        setLawOcuData(data.dataenum);
        // console.log(data.dataenum);
      } catch (e) {
        // console.log("e => " + e);
      } finally {
        setLoading(false);
      }
    }
    GetLawOcu()
  }, [borrowId])

  // ดึง master data จังหวัด


  const initialValues = {
    detailChangeCourseAr: detailChangeCourse,
    detailChangelawOccupationAr: detailChangeLawOccupationData,
    borrowId: borrowId,
    registerId: user.registerId,
  };

  const onSubmit = async (values) => {

    let postData = new FormData();

    Object.entries(values).forEach(([key, value]) => {
      // postData.append(key, value);
      if (key.slice(-2) === "Ar") {
        postData.append(key, JSON.stringify(value));
      } else {
        postData.append(key, value);
      }
    });

    try {
      let res = await fetch("api/ExtendAndChangeBorrow/saveChangeCourseOrTest", {
        method: "POST",
        body: postData,
      });

      let resJson = await res.json();

      if (resJson.status === 1) {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ",
          text: "โปรดรอเจ้าหน้าที่ตรวจสอบ",
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "บันทึกข้อมูลไม่สำเร็จ",
          text: `เนื่องจาก ${resJson.message}`,
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        });
      }
    } catch (e) {
      // console.log(e);
    }
  };

  const validationSchema = Yup.object().shape({
    // changeCourseDataAr:Yup.array().min(1,"กรุณาเลือกหลักสูตรที่จะเลื่อนฝึกอบรมอย่างน้อย 1 รายการ"),
    // lawOccupationDataAr:Yup.array().min(1,"กรุณาเลือกหลักสูตรที่จะเลื่อนฝึกอบรมอย่างน้อย 1 รายการ")
  });

  const courseDataValidateSchema = Yup.object().shape({
    trainCourseId: Yup.string().required("กรุณาเลือกหลักสูตร"),
    trainCourseNewName: Yup.string().required("กรุณากรอกชื่อหลักสูตร"),
  })

  async function courseDetailOnEdit(row) {
    // console.log("row =>", row)
    setIsCourseEditing(true)
    setSelectedCourseItem(row)
    modalToggleExtendCourse(!openModalForm)

  }

  function courseDetailOnDelete(row) {
    setDetailChangeCourse((current) =>
      current.filter((obj) => {
        return obj.id !== row.id;
      })
    );

  }

  async function testDetailOnEdit(row) {
    setIsTestEditing(true);
    setSelectedTestItem(row);
    modalToggleExtendTest(!openModalTestForm)
    // console.log(row)

  }

  function testDetailOnDelete(row) {
    // console.log(row)
    setDetailChangeLawOccupationData((current) =>
      current.filter((obj) => {
        return obj.id !== row.id;
      })
    );

  }

  const COLUMNS = [
    {
      Header: "ลำดับ",
      accessor: (_row, i) => i + 1,
    },
    {
      Header: "หลักสูตรเดิม",
      accessor: "trainCourseOldName",
    },
    {
      Header: "หลักสูตรใหม่",
      accessor: "trainCourseNewName"
    },
    {
      Header: "รายละเอียด",
      accessor: "id",
      Cell: ({ row, value }) => {
        return (
          <div className="text-center">
            <button
              type="button"
              className="btn border border-1 mx-1"
              onClick={() =>
                courseDetailOnEdit(row.original)
              }
            >
              แก้ไข
            </button>
            <button
              type="button"
              className="btn border border-1 mx-1"
              onClick={() =>
                courseDetailOnDelete(row.original)
              }
            >
              ลบ
            </button>
          </div>
        );
      },
    },
  ];

  const COLUMNSTEST = [
    {
      Header: "ลำดับ",
      accessor: (_row, i) => i + 1,
    },
    {
      Header: "สาขาอาชีพเดิม",
      accessor: "testOldName",
    },
    {
      Header: "สาขาอาชีพใหม่",
      accessor: "testNewLawOccupationName",
    },
    {
      Header: "รายละเอียด",
      accessor: "id",
      Cell: ({ row, value }) => {
        return (
          <div className="text-center">
            <button
              type="button"
              className="btn border border-1 mx-1"
              onClick={() =>
                testDetailOnEdit(row.original)
              }
            >
              แก้ไข
            </button>
            <button
              type="button"
              className="btn border border-1 mx-1"
              onClick={() =>
                testDetailOnDelete(row.original)
              }
            >
              ลบ
            </button>
          </div>
        );
      },
    },
  ];

  const courseDataInitialValues = {
    id: "",
    checkDuplicateValue: "",
    trainCourseOldName: "",
    trainCourseId: "",
    trainCourseNewName: "",
  }

  const lawOcuuDataInitialValues = {
    id: "",
    checkDuplicateTestValue: "",
    testOldName: "",
    testId: "",
    testNewLawOccupation: "",
    testNewLawOccupationName: "",

  };

  const handleSubmitCourseData = async (values, { setFieldError, setFieldTouched }) => {
    // console.log("values =>", values)
    const { trainCourseId } = values
    // console.log(trainCourseId)
    if (trainCourseId === "--กรุณาเลือกหลักสูตร--") {
      return;
    } else {
      let match;
      detailChangeCourse.map((item) => (
        match = item.hasOwnProperty('trainCourseId') && item.trainCourseId == Number(trainCourseId)
      ))
      if (match) {
        setFieldError("checkDuplicateValue", "หลักสูตรการฝึกอบรมนี้ได้ถูกเลือกไปแล้ว")
        setFieldTouched && setFieldError('trainCourseId', true);
      } else {

        let getTrainCourseName;
        courseData.forEach((course, i) => {
          if (course.trainCourseId == trainCourseId) {
            getTrainCourseName = course.courseName
          }
        })

        if (values.id !== "") {
          setDetailChangeCourse((old) =>
            old.map((row) => {
              if (row.id === values.id) {
                return {
                  ...values,
                  id: values.id,
                };
              }
              return row;
            })
          );
          modalToggleExtendCourse(!openModalForm)
        } else {
          let pre = {
            ...values,
            trainCourseOldName: getTrainCourseName,
            id: uuidv4()
          }
          setDetailChangeCourse((prev) => [...prev, pre]);
          modalToggleExtendCourse(!openModalForm)
        }
      }
    }


  }

  const handleSubmitLawOcuuData = async (values, { setFieldError, setFieldTouched }) => {
    // console.log("values =>", values)
    const { testId, testNewLawOccupation } = values;
    if (testId === "--กรุณาเลือกสาขาอาชีพ--" || testNewLawOccupation === "--กรุณาเลือกสาขาอาชีพ--") {
      return;
    } else {
      let match;
      detailChangeLawOccupationData.map((item) => (
        match = item.hasOwnProperty('testId') && item.testId == Number(testId)
      ))
      if (match) {
        setFieldError("checkDuplicateTestValue", "หลักสูตรการฝึกอบรมนี้ได้ถูกเลือกไปแล้ว")
        setFieldTouched && setFieldError('testId', true);
      } else {
        let getTestOldName;
        let getTestNewLawOccupationName;
        // loop เพื่อเอา ชื่อ course name เก่า
        lawOcuuByBorrowIdData.forEach((law, i) => {
          if (law.testId == testId) {
            getTestOldName = law.lawOcuupationName
          }
        })
        // loop เพื่อเอา ชื่อ lawOccupation อันใหม่
        lawOcuData.forEach((data, i) => {
          if (data.lawOccupationId == testNewLawOccupation) {
            getTestNewLawOccupationName = data.lawOccupationName
          }
        })

        if (values.id !== "") {
          setDetailChangeCourse((old) =>
            old.map((row) => {
              if (row.id === values.id) {
                return {
                  ...values,
                  id: values.id,
                };
              }
              return row;
            })
          );
          modalToggleExtendTest(!openModalTestForm)
        } else {
          let pre = {
            ...values,
            testOldName: getTestOldName,
            testNewLawOccupationName: getTestNewLawOccupationName,
            id: uuidv4()
          }
          setDetailChangeLawOccupationData((prev) => [...prev, pre]);
          modalToggleExtendTest(!openModalTestForm)
        }

      }
    }

    // lawOcuData.map((item) => {
    //   console.log(item)
    // })
  };


  const detailChangelawOcuuValidateSchema = Yup.object().shape({

  });


  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({ setFieldValue, values, touched, errors, isValid, dirty, handleBlur, handleChange }) => {

        return (
          <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
            {!loading ? (
              <div className="form-border">
                <Form className="p-5 mb-4">
                  {borrowInfo.map(data => (
                    <>
                      <FormGroup>
                        <Label>
                          เลขที่สัญญา
                        </Label>
                        <span className="input-color mx-2">
                          {data.contactNumber}
                        </span>
                      </FormGroup>
                      <FormGroup>
                        <Label>
                          ชื่อผู้กู้ยืม
                        </Label>
                        <span className="input-color mx-2">
                          {data.employee}
                        </span>
                      </FormGroup>
                    </>
                  ))}

                  <ErrorMessage name="changeCourseDataAr">{msg => <div className="text-danger">{msg}</div>}</ErrorMessage>
                  <ErrorMessage name="changeCourseDataAr">{msg => <div className="text-danger">{msg}</div>}</ErrorMessage>

                  {courseData.length ?
                    <>
                      <Formik
                        initialValues={isCourseEditing === true ? selectedCourseItem : courseDataInitialValues}
                        validationSchema={courseDataValidateSchema}
                        onSubmit={handleSubmitCourseData}
                        enableReinitialize
                      >{({ values, handleChange, handleBlur, setFieldValue, setValues, resetForm, errors, touched }) => {
                        // console.log(errors)
                        const onAddCourseDetail = () => {
                          setIsCourseEditing(false)
                          setSelectedCourseItem(null)
                          resetForm()
                          modalToggleExtendCourse();
                        };

                        const AddDetailCourseBtn = () => {
                          return (
                            <button
                              className="btn border border-1 text-white btn-green"
                              // style={{backgroundColor:"#0A66C2"}}
                              onClick={() => onAddCourseDetail()}
                            >
                              <BsPlusLg className="mx-2" />
                              เลือกหลักสูตรที่ต้องการเปลี่ยนแปลง
                            </button>
                          );
                        };
                        return (
                          <div className="">

                            <CreateTableComponent
                              column={COLUMNS}
                              dataInput={detailChangeCourse}
                              FormInput={AddDetailCourseBtn}
                              showEntrie={false}
                              showPage={false}
                            />

                            <Modal
                              isOpen={openModalForm}
                              toggle={modalToggleExtendCourse}
                              style={{ maxWidth: "600px", width: "100%" }}
                              centered
                              // scrollable
                              className="modal-bordered"
                              backdrop={"static"}
                              keyboard={false}
                            >
                              <ModalHeader className="styled-modal text-center" toggle={modalToggleExtendCourse}>
                                เลือกหลักสูตรที่ต้องการเปลี่ยนแปลง
                              </ModalHeader>
                              <ModalBody className="form-border">
                                <div style={{ maxWidth: "600px", width: "100%" }}>
                                  <Form autoComplete="off" className="">
                                    <div className="p-4">
                                      <FormGroup>
                                        <div>
                                          <Field name="id" type="text" className="d-none" />

                                          <Label>หลักสูตรการฝึกอบรม</Label>
                                          {touched.trainCourseId && errors.trainCourseId ? (
                                            <span className="text-left text-danger px-1">
                                              {errors.trainCourseId}
                                            </span>
                                          ) : null}
                                          <Field name="trainCourseId">
                                            {({ field, meta }) => (
                                              <Input
                                                type="select"
                                                className={meta.touched && meta.error ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                                {...field}
                                                onChange={(e) => {
                                                  handleChange(e)
                                                }}
                                              >
                                                <option defaultValue={"--กรุณาเลือกหลักสูตร--"}>
                                                  --กรุณาเลือกหลักสูตร--
                                                </option>
                                                {courseData.map((course, i) => (
                                                  <option
                                                    key={i}
                                                    value={course.trainCourseId}
                                                  >
                                                    {course.courseName}
                                                  </option>
                                                ))}
                                              </Input>
                                            )}
                                          </Field>

                                          <Label className="mt-3">กรุณากรอกชื่อหลักสูตรใหม่</Label>
                                          {touched.trainCourseNewName && errors.trainCourseNewName ? (
                                            <span className="text-left text-danger px-1">
                                              {errors.trainCourseNewName}
                                            </span>
                                          ) : null}
                                          <Field name="trainCourseNewName">
                                            {({ field, meta }) => (
                                              <Input
                                                type="text"
                                                className={
                                                  meta.touched && meta.error ?
                                                    "input-error rounded-pill text-center input-color" :
                                                    "rounded-pill text-center input-color"
                                                }
                                                {...field}
                                                onChange={(e) => {
                                                  handleChange(e)
                                                }}
                                              />
                                            )}
                                          </Field>
                                        </div>
                                      </FormGroup>
                                    </div>

                                    <ModalFooter className="d-flex justify-content-center">
                                      <button
                                        type="submit"
                                        className="btn-blue w-50"
                                      >
                                        บันทึก
                                      </button>
                                    </ModalFooter>
                                  </Form>
                                </div>
                              </ModalBody>
                            </Modal>
                          </div>
                        );
                      }}
                      </Formik>

                    </> : null}

                  {lawOcuuByBorrowIdData.length ?
                    <>
                      <Formik
                        initialValues={isTesteEditing === true ? selectedTestItem : lawOcuuDataInitialValues}
                        validationSchema={detailChangelawOcuuValidateSchema}
                        onSubmit={handleSubmitLawOcuuData}
                        enableReinitialize
                      >{({ values, handleChange, handleBlur, setFieldValue, setValues, resetForm, errors, touched }) => {

                        const onAddTestDetail = () => {
                          setIsTestEditing(false)
                          setSelectedTestItem(null)
                          // setSelectedTestItem(null)
                          // setIsTestEditing(false);
                          resetForm()
                          modalToggleExtendTest();
                        };

                        const AddDetailTestBtn = () => {
                          return (
                            <button
                              className="btn border border-1 text-white btn-green"
                              // style={{backgroundColor:"#0A66C2"}}
                              onClick={() => onAddTestDetail()}
                            >
                              <BsPlusLg className="mx-2" />
                              เลือกสาขาอาชีพที่ต้องการเปลี่ยนแปลง
                            </button>
                          );
                        };

                        return (
                          <div className="">

                            <CreateTableComponent
                              column={COLUMNSTEST}
                              dataInput={detailChangeLawOccupationData}
                              FormInput={AddDetailTestBtn}
                              showEntrie={false}
                              showPage={false}
                            />

                            <Modal
                              isOpen={openModalTestForm}
                              toggle={modalToggleExtendTest}
                              style={{ maxWidth: "600px", width: "100%" }}
                              centered
                              // scrollable
                              className="modal-bordered"
                              backdrop={"static"}
                              keyboard={false}
                            >
                              <ModalHeader className="styled-modal text-center" toggle={modalToggleExtendTest}>
                                เลือกสาขาอาชีพที่ต้องการเปลี่ยนแปลง
                              </ModalHeader>
                              <ModalBody className="form-border">
                                <div style={{ maxWidth: "600px", width: "100%" }}>
                                  <Form autoComplete="off" className="">
                                    <div className="p-4">
                                      <FormGroup>
                                        <Field name="id" className="d-none" />
                                        <div>
                                          <Label>กรุณาสาขาอาชีพ</Label>
                                          {touched.testId && errors.testId ? (
                                            <span className="text-left text-danger px-1">
                                              {errors.testId}
                                            </span>
                                          ) : null}
                                          <Field name="testId">
                                            {({ field, meta }) => (
                                              <Input
                                                type="select"
                                                className={meta.touched && meta.error ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                                {...field}
                                              >
                                                <option defaultValue={"--กรุณาเลือกสาขาอาชีพ--"}>
                                                  --กรุณาเลือกสาขาอาชีพ--
                                                </option>
                                                {lawOcuuByBorrowIdData.map((law, i) => (
                                                  <option
                                                    key={i}
                                                    value={law.testId}
                                                  >
                                                    {law.lawOcuupationName}
                                                  </option>
                                                ))}
                                              </Input>
                                            )}
                                          </Field>
                                          <Label className="mt-3">กรุณาเลือกสาขาอาชีพใหม่</Label>
                                          {touched.testId && errors.testId ? (
                                            <span className="text-left text-danger px-1">
                                              {errors.testId}
                                            </span>
                                          ) : null}
                                          <Field name="testNewLawOccupation">
                                            {({ field, meta }) => (
                                              <Input
                                                type="select"
                                                className={meta.touched && meta.error ? "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"}
                                                {...field}
                                              >
                                                <option defaultValue={"--กรุณาเลือกสาขาอาชีพ--"}>
                                                  --กรุณาเลือกสาขาอาชีพ--
                                                </option>
                                                {lawOcuData.map((lawOcu, index) => (
                                                  <option
                                                    key={lawOcu.lawOccupationId}
                                                    value={lawOcu.lawOccupationId}
                                                  >
                                                    {/* สาขาที่ {lawOcu.lawOccupationId}{" "} */}
                                                    {lawOcu.lawOccupationName}
                                                  </option>
                                                ))}
                                              </Input>
                                            )}
                                          </Field>
                                        </div>

                                      </FormGroup>
                                    </div>


                                    <ModalFooter className="d-flex justify-content-center">
                                      <button
                                        type="submit"
                                        className="btn-blue w-50"
                                      >
                                        บันทึก
                                      </button>
                                    </ModalFooter>
                                  </Form>
                                </div>
                              </ModalBody>
                            </Modal>
                          </div>
                        );
                      }}
                      </Formik>

                    </> : null}

                  <div className="d-flex justify-content-center align-items-center mt-5">
                    <button
                      type="submit"
                      className="btn-blue px-4 w-25"
                    >
                      ส่งคำขอ
                    </button>
                  </div>
                </Form>
              </div>
            ) : (
              <Loading />
            )}
          </Container>
        );
      }}
    </Formik>
  );
}
